import { IS_MOBILE } from '../constants/const'
import { LENIS_SCROLL_GLOBAL } from '../scroll'
import { onAdd } from '../utils/class-list'
import { onSelect, onSelectAll } from '../utils/dom'
import { onInitObserver } from '../utils/observer'
import { onScrollAnime } from './animations'
import OBJ_ANIMATIONS from './anime-animations'
import {
  SEL_TITLE_1,
  SEL_TITLE_2,
  SEL_TITLE_3,
  SEL_TITLE_4,
  SEL_TITLE_5,
  SEL_TITLE_6,
  SEL_TITLE_7,
  SEL_TITLE_8,
  SEL_TITLE_9,
  SEL_TITLE_10,
  SEL_TITLE_11,
  SEL_SHADOW_HOTEL,
  SEL_HOTEL,
} from './anime-selectors'

const SCROLL_ANIME = {
  status: false,
}

function onShowTitles(entries, observer) {
  entries.forEach((entrie) => {
    if (entrie.isIntersecting && entrie.target) {
      onAdd(entrie.target, 'anime-title--visible')
    }
  })
}

function onShowHotel(entries, observer) {
  entries.forEach((entrie) => {
    if (entrie.isIntersecting && entrie.target) {
      onAdd(entrie.target, 'icon--visible')
    }
  })
}

let observeItemsTitle = [SEL_TITLE_1, SEL_TITLE_2, SEL_TITLE_3, SEL_TITLE_4, SEL_TITLE_5, SEL_TITLE_6, SEL_TITLE_7, SEL_TITLE_8, SEL_TITLE_9, SEL_TITLE_10, SEL_TITLE_11]
let observeItemsHotel = [SEL_SHADOW_HOTEL, SEL_HOTEL]

function onAnimeHomePage() {
  const { ANI_BELT, ANI_PICTURE_1, ANI_PICTURE_2, ANI_PICTURE_3, ANI_PICTURE_4, ANI_PICTURE_ALL } = OBJ_ANIMATIONS

  ANI_BELT.play()
  ANI_BELT.finished.then(() => {
    let figures = onSelectAll('.bl-benefits-template--figure')
    onAdd(figures, 'figure--visible')
  })

  // show title
  onInitObserver(observeItemsTitle, onShowTitles, {
    root: null,
    rootMargin: '-180px 200px',
    threshold: 0.8,
  })

  // show title
  onInitObserver(observeItemsHotel, onShowHotel, {
    root: null,
    rootMargin: '0px',
    threshold: 0.6,
  })

  LENIS_SCROLL_GLOBAL.on('scroll', ({ scroll, limit, progress }) => {
    let sectionPoints = onSelect('.bl-benefits-items--box-title.anime-title.anime-title--visible')
    if (sectionPoints !== null) {
      ANI_PICTURE_ALL.seek(onScrollAnime(sectionPoints, 8000, 200) * ANI_PICTURE_ALL.duration)
    }

    // if (progress * 100 >= 28.2 && ANI_PICTURE_2.progress === 0) ANI_PICTURE_2.play()
    // if (progress * 100 >= 32.2 && ANI_PICTURE_3.progress === 0) ANI_PICTURE_3.play()
    // if (progress * 100 >= 48.2 && ANI_PICTURE_4.progress === 0) ANI_PICTURE_4.play()
    // if (limit >= 0.04 && !SCROLL_ANIME.status) {
    //   SCROLL_ANIME.status = true
    //   ANI_PICTURE_1.play()
    // }
  })
}

function onAnimeHomePageMobile() {
  let figures = onSelectAll('.bl-benefits-template--figure')
  onAdd(figures, 'figure--visible')

  // show title
  onInitObserver(observeItemsTitle, onShowTitles, {
    root: null,
    rootMargin: '-180px 200px',
    threshold: 0.8,
  })

  // show title
  onInitObserver(observeItemsHotel, onShowHotel, {
    root: null,
    rootMargin: '0px',
    threshold: 0.6,
  })
}

let homePage = onSelect('body#home')
if (homePage && !IS_MOBILE) onAnimeHomePage()
if (homePage && IS_MOBILE) onAnimeHomePageMobile()
